'use strict';
const googlePhotosToMindmupMetadata = require('./google-photos-to-mindmup-metadata');
module.exports = function GoogleImagePicker(picker, navigatorShim, googleDriveService) {
	const self = this;
	if (!picker || !navigatorShim || !googleDriveService) {
		throw new Error('invalid-args');
	}
	self.pickImage = function (userProfile, options) {
		const onImagePicked = async function (picked) {
			if (options && options.notify) {
				options.notify('uploading', picked.url);
			}
			const service = picked.item.service || picked.item.serviceId;
			if (service === 'picasa') {
				return Promise.resolve(googlePhotosToMindmupMetadata(picked.url, picked.item));
			} else if (service === 'docs') {
				const url = await googleDriveService.fetchFileContentsAsDataUri(picked.item.id);
				return {url};
			} else {
				return navigatorShim.convertToPng(picked.url)
					.then(result => ({
						url: result
					}))
					.catch(() => {
						//console.error(e);
						throw 'image-error';
					});
			}
		};

		return picker.pickImage(userProfile, 'Select an image').then(onImagePicked, function () {
			throw 'cancel';
		});
	};
};
